// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nbutton.disabled[data-v-1d2fcf8a] {\n  cursor: not-allowed;\n}\n", ""]);
// Exports
module.exports = exports;
